var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgUnchecked = function SvgUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.95,
    height: 4.95
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".unchecked_svgr__a{fill:#c4c4c4}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108.439 -606.354)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "unchecked_svgr__a",
    width: 6,
    height: 1,
    rx: 0.5,
    transform: "rotate(-45 791.274 174.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "unchecked_svgr__a",
    width: 6,
    height: 1,
    rx: 0.5,
    transform: "rotate(45 -677.361 434.928)"
  }))));
};

export default SvgUnchecked;